export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CityInput.vue?vue&type=template&id=5765a20b&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/CityInput.vue?vue&type=template&id=5765a20b&
// module id = 1137
// module chunks = 0